export type WindowSizePreset = 'default' | 'form' | 'grid' | 'largeForm';

export const WINDOW_SIZE_PRESETS = {
  default: {
    width: 400
  },
  form: {
    width: 400
  },
  grid: {
    width: 1000,
    height: 560
  },
  largeForm: {
    maxWidth: 'lg',
    width: '90%',
    height: '93%'
  }
} satisfies Record<WindowSizePreset, Record<string, unknown>>;
